/// <reference types="./Types.d.ts" />
export const RichTextNodeType = {
    code: 'code',
    'code-highlight': 'code-highlight',
    component: 'component',
    entity: 'entity',
    entityLink: 'entityLink',
    heading: 'heading',
    linebreak: 'linebreak',
    link: 'link',
    list: 'list',
    listitem: 'listitem',
    paragraph: 'paragraph',
    root: 'root',
    tab: 'tab',
    text: 'text',
};
export const EntityStatus = {
    /** The entity has never been published. */
    draft: 'draft',
    /** The entity is currently published and has no pending changes. */
    published: 'published',
    /** The entity is currently published but has changes that are not published. */
    modified: 'modified',
    /** The entity has previously been published, but is unpublished. */
    withdrawn: 'withdrawn',
    /** The entity is archived. */
    archived: 'archived',
};
export const EntityQueryOrder = {
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    name: 'name',
};
export const PublishedEntityQueryOrder = {
    createdAt: 'createdAt',
    name: 'name',
};
//# sourceMappingURL=Types.js.map